// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import "ol/ol.css";
import 'normalize.css/normalize.css'
import 'animate.css/animate.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import store from './store'
import router from './router'
import '@/router/permission'
import '@/components'
import "@/directive"
import 'swiper/dist/css/swiper.css';
// import "viewerjs/dist/viewer.css";
import 'babel-polyfill'
import promise from 'es6-promise'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
promise.polyfill()

// import Viewer from  'v-viewer'
// Vue.use(Viewer, {
//   defaultOptions: {
//     zIndex: 9999
//   }
// })

Vue.config.productionTip = false
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js